import { useEffect } from "react";
import axios from "axios";
import liff from "@line/liff";
import LoadingScreen from "../Loading/LoadingScreen";
import { CURRENT_ENV } from "../../Utills/constants";

function BonusTimeSecret() {
    useEffect(() => {
        const initLiff = async () => {
            try {
                await liff.init({
                    liffId: CURRENT_ENV.LIFF_ID,
                });

                if (!liff.isLoggedIn()) {
                    liff.login();
                    return;
                }

                const res = await axios.get(
                    `${CURRENT_ENV.API_BASE_URL}/bonustimeSecret`
                );

                const data = res.data;
                await liff.sendMessages([data]);
                liff.closeWindow();

            } catch (error) {
                console.error(error);

                alert(
                    `Error: ${error?.message ||
                    JSON.stringify(error, null, 2)
                    }`
                );
            }
        };

        initLiff();
    }, []);

    return <LoadingScreen />;
}

export default BonusTimeSecret